import { render, staticRenderFns } from "./Entery.vue?vue&type=template&id=7036c41a&scoped=true&"
import script from "./Entery.vue?vue&type=script&lang=js&"
export * from "./Entery.vue?vue&type=script&lang=js&"
import style0 from "./Entery.vue?vue&type=style&index=0&id=7036c41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7036c41a",
  null
  
)

export default component.exports
import {QLayout,QPageContainer,QPage,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QPageContainer,QPage,QCard,QCardSection})
